import { faEllipsisVertical, faPenToSquare, faUpload, faTrash, faXmarkCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState } from 'react'
import { Button, Dropdown, Form, Table } from 'react-bootstrap';
import { formatDate } from '../../../../../components/helper/Date';
import CustomToggle from '../../../../../components/toggle/CustomToggle';
import ShiftModal from '../../../../../components/Modal/Shift.model';
import { useNavigate, useParams } from 'react-router';
import ExamService from '../../../../../services/exam.service';
import toast from 'react-hot-toast';
import AdminService from '../../../../../services/admin.service';
import EditShiftModal from '../../../../../components/Modal/EditShift.modal';
import ConfirmModal from '../../../../../components/Modal/Confirm.modal';

interface IProps {
    exam: any;
    refreshExam: any;
}

export default function ExamShifts({ exam, refreshExam }: IProps) {
    const [showShiftModal, setShowShiftModal] = useState<boolean>(false);
    const [editShift, setEditShift] = useState<any>(null);
    const params = useParams();
    const navigate = useNavigate();
    const [deleteShiftid, setDeleteShiftId] = useState<string>("");



    const handleToggleShiftIsBiometricAllowed = async (shiftId: any) => {
        await ExamService.toggleShiftIsBiometricAllowed(params.examId, shiftId)
            .then((res) => {
                if (res.status === 200) {
                    toast.success("Shift biometric allowed toggled successfully");
                    refreshExam();
                }
            })
            .catch((err) => {
                toast.error(err.response.data);
            });
    };

    const deleteShift = async () => {
        if (!deleteShiftid) {
            return;
        }
        await AdminService.deleteShift(params.examId, deleteShiftid)
            .then((res) => {
                if (res.status == 200) {
                    toast.success("Shift deleted successfully");
                    refreshExam();
                    setDeleteShiftId("");
                }
            })
            .catch((e) => {
                toast.error("Unable to delete shift");
                console.error(e);
            });
    };

    return (
        <>
            <div className="mt-4">
                <div className="d-flex justify-content-between align-items-center">
                    <p
                        style={{
                            fontSize: "18px",
                            fontWeight: "bold",
                        }}
                    >
                        Shifts
                    </p>
                    <Button
                        variant="outline-primary"
                        className="fw-bold"
                        size="sm"
                        onClick={() => {
                            setShowShiftModal(true);
                        }}
                    >
                        Add Shifts
                    </Button>
                </div>

                <div className="mt-3">
                    <Table striped hover className="xcn-text-12">
                        <thead>
                            <tr>
                                <th>
                                    <span className="fw-bold">Shift Name</span>
                                </th>
                                <th>
                                    <span className="fw-bold">Status</span>
                                </th>
                                <th>
                                    <span className="fw-bold">Biometric Allowed</span>
                                </th>
                                <th>
                                    <span className="fw-bold">Start time</span>
                                </th>

                                <th>
                                    <span className="fw-bold">End time</span>
                                </th>
                                <th>
                                    <span className="fw-bold">
                                        Biometric Start time
                                    </span>
                                </th>
                                <th>
                                    <span className="fw-bold">Biometric End time</span>
                                </th>
                                <th>
                                    <span className="fw-bold">Action</span>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {exam && exam.shifts && exam.shifts.length > 0
                                ? exam.shifts.map((shift: any) => {
                                    return (
                                        <>
                                            <tr>
                                                <td className="xcn-text-10 fw-bold text-primary">
                                                    {shift && shift.shiftName}
                                                </td>
                                                <td className="xcn-text-10 fw-bold text-primary">
                                                    {shift && shift.isLive ? (
                                                        <span className="text-success">
                                                            Live
                                                        </span>
                                                    ) : (
                                                        <span className="text-danger">
                                                            Not-live
                                                        </span>
                                                    )}
                                                </td>
                                                <td className="xcn-text-10 fw-bold text-primary">
                                                    <Form.Switch
                                                        checked={
                                                            shift && shift.isBiometricAllowed
                                                        }
                                                        onChange={(e) =>
                                                            handleToggleShiftIsBiometricAllowed(
                                                                shift._id
                                                            )
                                                        }
                                                    />
                                                </td>
                                                <td className="xcn-text-10 fw-bold text-secondary">
                                                    {formatDate(shift && shift.startTime)}
                                                </td>
                                                <td className="xcn-text-10 fw-bold text-secondary">
                                                    {formatDate(shift && shift.endTime)}
                                                </td>
                                                <td className="xcn-text-10 fw-bold text-secondary">
                                                    {formatDate(
                                                        shift && shift.biometricStartTime
                                                    )}
                                                </td>
                                                <td className="xcn-text-10 fw-bold text-secondary">
                                                    {formatDate(
                                                        shift && shift.biometriEndTime
                                                    )}
                                                </td>
                                                <td>
                                                    <Dropdown>
                                                        <Dropdown.Toggle
                                                            as={CustomToggle}
                                                            id="dropdown-custom-components"
                                                        >
                                                            <FontAwesomeIcon
                                                                icon={faEllipsisVertical}
                                                            />
                                                        </Dropdown.Toggle>

                                                        <Dropdown.Menu>
                                                            <Dropdown.Item
                                                                onClick={() => setEditShift(shift)}
                                                            >
                                                                <FontAwesomeIcon
                                                                    icon={faPenToSquare}
                                                                    className="text-primary me-2"
                                                                />
                                                                <span className="">Edit</span>
                                                            </Dropdown.Item>
                                                            <Dropdown.Item
                                                                onClick={() => {
                                                                    navigate(
                                                                        "/dashboard/upload/" +
                                                                        exam._id +
                                                                        "/" +
                                                                        shift._id
                                                                    );
                                                                }}
                                                            >
                                                                <FontAwesomeIcon
                                                                    icon={faUpload}
                                                                    className="text-primary me-2"
                                                                />
                                                                <span className="">
                                                                    Upload Data
                                                                </span>
                                                            </Dropdown.Item>
                                                            <Dropdown.Divider />
                                                            <Dropdown.Item
                                                                onClick={() => {
                                                                    setDeleteShiftId(shift._id);
                                                                }}
                                                            >
                                                                <FontAwesomeIcon
                                                                    icon={faTrash}
                                                                    className="text-danger me-2"
                                                                />
                                                                <span className="text-danger">
                                                                    Delete
                                                                </span>
                                                            </Dropdown.Item>
                                                        </Dropdown.Menu>
                                                    </Dropdown>
                                                </td>
                                            </tr>
                                        </>
                                    );
                                })
                                : "No table data"}
                        </tbody>
                    </Table>
                </div>
            </div>

            <ShiftModal
                params={params.examId}
                show={showShiftModal}
                handleClose={() => setShowShiftModal(false)}
                reload={refreshExam}
            />

            <EditShiftModal
                show={editShift && editShift?._id}
                handleClose={() => setEditShift(null)}
                shift={editShift}
                reload={refreshExam}
            />

            <ConfirmModal
                titleText={"Confirm Shift Delete"}
                bodyText={"Are you sure you want to delete this shift?"}
                show={deleteShiftid !== ''}
                onHide={() => setDeleteShiftId("")}
                button={[
                    {
                        label: (
                            <>
                                <FontAwesomeIcon icon={faXmarkCircle} /> Cancel
                            </>
                        ),
                        action: () => setDeleteShiftId(""),
                        variant: "secondary",
                    },
                    {
                        label: (
                            <>
                                <FontAwesomeIcon icon={faTrash} /> Delete
                            </>
                        ),
                        action: deleteShift,
                        variant: "danger",
                    },
                ]}
            />
        </>
    )
}